import { useState, useEffect} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextInput } from '../../components/input'
import GoBack from '../../components/back/GoBack'
import SettingsMenu from '../staticscreens/SettingsMenu'
import { CreateSubscriptionService, GetSubscriptionService, UpdateSubscriptionService } from '../../services/admin/SubscriptionServices'
import { GetUserWFHOffice } from '../../services/AuthServices'
import { Select } from 'antd'
import Uploader from '../../components/Uploader'
import { UploadExcelClientService, UploadTeacherExcelClientService } from '../../services/ClientServices'
import { GetTeacherListService, GetTeacherSearchService } from '../../services/class_booking/TeacherServices'

function ClientExcelUploadToTeacher() {
 
  const [data,setdata] = useState({file:'',user:[]});  
  const [error,seterror] = useState({file:'',user:[]}); 

  const [users,setusers] = useState([])
  
   useEffect(()=>{
      getdata()
    },[])


    
  
    async function getdata() {
      const response = await GetTeacherSearchService('',1,'Counsellor','')
      let arr = []
      response?.data?.datas?.forEach((d)=>{
        arr.push({label:d?.name,value:d?._id})
      })
          setusers(arr)
    }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }
  

  async function resetform(){
    setdata({points:'',})
    seterror({points:'',})
  }

  async function submitdata() {
    if(data.user.length == 0){
        seterror({...error,user:'User is required for assigning*'})
    }else if(!data.file){
        seterror({...error,file:'File field is required*'})
    }else{
      const fd = new FormData()
      fd.append('file',data?.file)
      fd.append('teacherList',JSON.stringify(data?.user))
      const response = await UploadTeacherExcelClientService(fd)
      if (response.status === 201) {
        resetform()
        toast.success('Teacher Client Excel File Upload Successfully')
      } 
    }
  }

  function openFile(v){
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${v}`
    window.open(url,'_blank')
  }


  function UploadFile(e,name){
      const file = e;
        if (!file) return;
        const allowedExtensions = ["xls", "xlsx"];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
          toast.error("Only Excel files (.xls, .xlsx) are allowed!");
          return;
        }else{
          setdata({...data,file:e})
        }
  }

   async function handleSearch(value,e1){
    if(e1 === 'teacher'){
      const response = await GetTeacherSearchService(value,1,'Counsellor',"")
      let arr = []
      response?.data?.datas?.forEach((d)=>{
        arr.push({label:d?.name,value:d?._id})
      })
      setusers(arr)
    }
  }
  

  

  return (
    <div className='md:flex '>


    <SettingsMenu />
 
  <div className='sm:w-full lg:w-72 px-4 pt-5' >


      <GoBack /> 
      
      

        <h6 className='font-bold'>Teacher Client Excel Upload</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to upload the <b>Teacher Client Excel for assign</b>.</h6>
     

      
        
        <h6 className='text-[11px] mb-1 mt-2'>Select Teacher </h6>

        <Select 
          mode='multiple'
          value={data?.user}
          bordered={false}
          filterOption={false}
                  showSearch
                  onSearch={(e)=>handleSearch(e,'teacher')}
          className='border border-l border-l-4 border-l-slate-700 min-h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
          options={users}
          placeholder={<span className="text-[0px] text-gray-300 "></span>}
          onChange={(e)=>setdata({...data,user:e})}
          />

            <Uploader error={error?.file} name="file" required={true} label={'File'} image={data?.file}  setimagefunc={(e)=>{UploadFile(e,'file');seterror({...error,file:''})}}  removeimageuploadfunc = {()=>{setdata({...data,file:''});seterror({...error,file:''})}} />


          
          <div className='my-5'>
           <ButtonFilledAutoWidth btnName="Save"  onClick={submitdata} />  
          </div>



    </div>
    </div>
  )
}

export default ClientExcelUploadToTeacher